/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationGroupSchema } from "./comboCalculationGroupSchema.ts";

export const comboCalculationDetailSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	groups: z.array(comboCalculationGroupSchema),
	front_item_id: z.uuid().nullish(),
});
